export default __webpack_public_path__ + "media/images/front/about/features/travel-ceb76d4f9a27b732643e5ae85ca33b62.png";